import { useApi } from 'gf-ui';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { Container } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router';
import { apiQuestionario } from '../../libQuestionario/api/apiQuestionario';
import BreadcrumbGF from '../components/BreadcrumbGF';
import Subcategorie from '../components/Subcategorie';

const QCategoria = ({ homeRoute, root, title, headerComponent }) => {
  const { ID_MA_CATEGORIA } = useParams()  
  const navigate = useNavigate()  
  const _apiQuestionario = useApi(apiQuestionario, null, root)
  const shouldInit = useRef(true)
  const [categoria, setCategoria] = useState(null)  
  const [modelli, setModelli] = useState(null)

  const getModelli = useCallback(() => {
    _apiQuestionario.fnElencoSubcategorie(res => {
      setCategoria(res.categoria)      
      setModelli(res.modelli)
    }, { ID_CATEGORIA: ID_MA_CATEGORIA })
  }, [ID_MA_CATEGORIA, _apiQuestionario])

  const onSelModello = (modello) => {
    if (parseInt(modello.TOT_FIGLI) === 0) {
      navigate(`${homeRoute}/scheda/nuova/modello/${modello.ID_MA_MODELLO}`)
    } else {
      navigate(`${homeRoute}/subcategoria/${ID_MA_CATEGORIA}/${modello.ID_MA_MODELLO}`)
    }
  }  

  const breadcrumbItems = useMemo(()=>{
    return [      
      { path: `${homeRoute}`, label: title },
      { label: categoria && categoria.DESCRIZIONE }
    ]
  }, [categoria, homeRoute, title])

  useEffect(() => {
    if (shouldInit.current && _apiQuestionario) {
      shouldInit.current = false            
      getModelli()
    }
  }, [_apiQuestionario, getModelli])

  return <>
    { headerComponent }

    <BreadcrumbGF items={breadcrumbItems} />

    <h2 className='pt-4 text-center'>{categoria && categoria.DESCRIZIONE}</h2>
  
    <div className='w-100 p-0 m-0 bg-light'>
      <Container className='py-4'>      
        <Subcategorie categorie={modelli} descField="MODELLO" onSelCategoria={onSelModello} />      
      </Container>
    </div>
  </>
}

export default QCategoria